import { Navigate } from 'react-router-dom';
import ROUTES from '../../../../core/constants/routes.constants';
import { useEffect } from 'react';
import { useAppDispatch } from '../../../../store';
import { reset as resetParticipants } from '../../../../store/participants';
import { reset as resetParticipant } from '../../../../store/participant';

function Logout() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(resetParticipants());
    dispatch(resetParticipant());
  }, [dispatch]);
  return <Navigate to={ROUTES.root} />;
}

export default Logout;
